import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import Moveable from 'dojo/dnd/Moveable';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from 'moreCore/UI/GenericDialog/GenericDialog';
import OccurrenceForm from 'WidgetCollection/Occurrence/OccurrenceForm/OccurrenceForm';
import template from './OccurrenceFormDialog.html?raw';
export default declare("WidgetCollection.JDM.Occurrence.OccurrenceFormDialog", [_WidgetBaseSP], {
        templateString: template,

        occurrenceGUID: null,

        occurrenceForm: null,
        //occurrenceList: null, // ist schon im Template
        _submitInProgess: false,
        employee: null,
        entity: null,
        _selectedFiltermode: "",//"MyOccurrences",
        _occurrenceFiltersInitialized: false,
        genericDialog: null,

        _isCancelAvailable: -3, // +1 wenn es ein Entity gibt; 
        //+ 1 wenn Status es erlaubt; 
        //+ 1 wenn das Entity "mir" gehört; 
        //+ 1 wenn dort noch kein cancelrequest aktiv ist; 
        //- 1 wenn dirty;
        // Ziel: 1 oder mehr

        startup: function (occurrenceGUID, bReadOnly, commentId) {
            //console.log("startup occurrencedialog", occurrenceID, bReadOnly, commentId);
            this.inherited(arguments);
            
            this.occurrenceGUID = occurrenceGUID;
            this.showOccurrenceForm(occurrenceGUID, bReadOnly, commentId);
        },

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);
        },

        _setEmployeeAttr: function (value) {
            this.employee = value;

            if (this.entity != null && this.employee != null) {
                if (this.entity.ref_reporter.ID == this.employee.ID) {
                    this._isCancelAvailable++;
                    console.debug("occurrenceformdlg employee", this.employee, this._isCancelAvailable);
                    this.setCancelRequestBtnStyle();
                }
            }
        },

        _onLoadOccurrenceError: function (error) {
            this.StandbyStop();
            this.showMessage(this.translations["OccurrenceFormDialog__ErrorLoading"], error.Message, null, lang.hitch(this, "_onClick_Modal_Close"));
            //alert(error.message);
        },

        showOccurrenceForm: function (occurrenceGUID, bReadOnly, commentId) {
            console.log("showOccurrenceForm", occurrenceGUID);
            if (this.occurrenceForm == null) {
                this.occurrenceForm = new OccurrenceForm();

                //new Moveable(this.modalWindow, { handle: this.headerNode });

                //this.occurrenceForm.itemID = this.item.ref_associate;
                this.occurrenceForm.employee = this.employee;

                this.occurrenceForm.errorCallback = lang.hitch(this, "_onOccurrenceFormError");

                //domAttr.set(this.headerNode, "innerHTML", /*"neue Meldung erfassen"*/this.translations["OccurrenceHome__NewDialog_Header"]);

                domConstruct.place(this.occurrenceForm.domNode, this.modalContentNode);

                on(this.occurrenceForm, "EntityChange", lang.hitch(this, "onChange_Entity"));
                this.onChange_Entity();

                if (occurrenceGUID != null && typeof (occurrenceGUID) != "undefined") {
                    this.occurrenceForm.entityGUID = occurrenceGUID;
                    domAttr.set(this.headerNode, "innerHTML", /*"Meldung bearbeiten"*/this.translations["OccurrenceHome__NewDialog_HeaderEdit"]);

                    this.setUrlParameter("view", occurrenceGUID);
                } 

                this.onChange_DirtyState(false);
                
                if (true) {//bReadOnly != true) {
                    on(this.occurrenceForm, "DirtyStateChange", lang.hitch(this, "onChange_DirtyState"));
                }
                this.occurrenceForm.startup();

                if (bReadOnly === false || bReadOnly === true) {
                    this.occurrenceForm.set("Readonly", bReadOnly);
                }

                

                if (typeof (commentId) == "string") {
                    this.occurrenceForm.showComment(commentId);
                } else {
                    //var occHome = document.occurrenceHome;
                    //occHome.siteActionReset("view?id=" + occurrenceGUID);
                }
            }

            domClass.remove(this.modalDlg, "w3-hide");
            domClass.add(this.modalDlg, "w3-show");
        },

        onChange_Entity: function (jsonEntity) {
            this.entity = jsonEntity;

            if (typeof (jsonEntity) == "undefined" || jsonEntity == null) {
                domAttr.set(this.headerNode, "innerHTML", /*"neue Meldung erfassen"*/this.translations["OccurrenceHome__NewDialog_Header"]);
                domStyle.set(this.headerRow, "background-color", "unset");
                domStyle.set(this.modalWindow, "box-shadow", "0px 0px 16px 0px #00000077");
                domStyle.set(this.modalWindow, "outline", "2px solid silver");
                domClass.add(this.headerRow, "w3-light-grey");

                domClass.add(this.headerBtnReload, "w3-hide");
            }

            else {
                domAttr.set(this.headerNode, "innerHTML", this.translations["OccurrenceHome__EditDialog_Header"].format(jsonEntity.Number, jsonEntity.ref_occurrence_status.description));//"Meldung bearbeiten - " + jsonEntity.Number + " - " + jsonEntity.ref_occurrence_status.description);
                domStyle.set(this.headerRow, "background-color", "#" + jsonEntity.ref_occurrence_status.hexColor);
                domStyle.set(this.modalWindow, "boxShadow",
                    "inset 0px 0px 0px 4px #" + jsonEntity.ref_occurrence_status.hexColor + "88, " +
                    "0px 0px 16px 0px #00000077");// + 
                    //"0px 0px 16px 32px #" + jsonEntity.ref_occurrence_status.hexColor + "88"
                //);
                domStyle.set(this.modalWindow, "outline", "2px solid #" + jsonEntity.ref_occurrence_status.hexColor)
                domClass.remove(this.headerRow, "w3-light-grey");
                domClass.remove(this.headerBtnReload, "w3-hide");

                if (this.employee != null) {
                    if (jsonEntity.ref_reporter.ID == this.employee.ID) {
                        this._isCancelAvailable++;
                    }
                }

                if (jsonEntity.ref_occurrence_status.is_cancel_request_enabled == true) {
                    this._isCancelAvailable++;
                }

                if (jsonEntity.is_cancellation_requested != true) {
                    this._isCancelAvailable++;
                }

                console.debug("occurrenceformdlg entity", jsonEntity, this._isCancelAvailable, this.employee);

                this.setCancelRequestBtnStyle();
            }
        },

        setCancelRequestBtnStyle: function () {
            var fct1 = domClass.add;
            var fct2 = domClass.remove;

            

            if (this._isCancelAvailable >= 1) {
                fct1 = domClass.remove;
                fct2 = domClass.add;
            }

            fct1(this.btn_cancelTicket, "w3-disabled");
            fct2(this.btn_cancelTicket, "w3-red mds-hover-bright");
        },

        onChange_DirtyState: function (state) {
            console.log("new dirtystate: ", state);

            if (state === true) {
                domClass.add(this.btn_submit, "accentcolor mds-hover-bright");
                domClass.remove(this.btn_submit, "w3-disabled");
                this._isCancelAvailable--;
            } else {
                domClass.remove(this.btn_submit, "accentcolor mds-hover-bright");
                domClass.add(this.btn_submit, "w3-disabled");
                this._isCancelAvailable++;
            }

            this.setCancelRequestBtnStyle();
        },

        _onClick_CancelTicket: function (evt) {

            if (this._isCancelAvailable < 1) return;

            var dialog = new GenericDialog;

            domStyle.set(dialog.textNode, "height", "unset");
            dialog.destroyOnClose = false;

            dialog.set("header", this.translations["OccurrenceForm__DialogCancelTicketHeader"].format(this.entity.Number));//taskEntity.Number + " erledigen");
            //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
            dialog.set("SubTitle", this.translations["OccurrenceForm__DialogCancelTicketSubtitle"].format(this.entity.Number, this.entity.ref_reporter.DispName));

            dialog.set("ok", true);
            dialog.set("cancel", true);
            //dialog.set("content", "Hier Freitexteingabe");

            var input = domConstruct.create("textarea");
            domClass.add(input, "w3-input w3-block");
            dialog.addNodeToContent(input);
            //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");

            // verhinden dass mit "Enter" der Dialog beendet wird
            on(input, "keyup", function (evt) {
                evt.stopPropagation();
            });

            dialog.set("callback", lang.hitch(this, "_onCancelTicketDlgResponse", input, dialog));

            dialog.show();

        },

        _onCancelTicketDlgResponse: function (input, dialog, response) {
            console.log("_onCancelTicketDlgResponse", input, dialog, response);

            if (response == 1) {
                var stringParams = JSON.stringify({
                    note: input.value,
                    occurrenceGUID: this.occurrenceGUID,
                    "cancellationRequested": true // this.is_cancellation_requested != true // inzwischen mal nicht rückgängig machbar

                });
                var url = window.appRoot + "Occurrence/RequestCancellation";

                this._request = this.RequestManager.post(
                    url,
                    {
                        jsonData: stringParams,
                    },
                    lang.hitch(this, "_onRequestCancelTicketResponse", dialog),
                    lang.hitch(this, "_onRequestCancelTicketError"),
                    false // sync
                );
            }
        },

        _onRequestCancelTicketResponse: function (response) {
            this._isCancelAvailable = -10;
            this.occurrenceForm.startup(true);
        },

        _onRequestCancelTicketError: function (error) {
            console.error("_onRequestCancelTicketError", error);
            this.showMessage(this.translations["OccurrenceFormDialog__ErrorCancelTicket"], error.Message, null, null);// lang.hitch(this, "_onClick_Modal_Close"));

        },

        _onClick_Submit: function (evt) {

            if (this._submitInProgess === true || this.occurrenceForm.isDirty != true) {
                return;
            }

            if (this.occurrenceForm.isSpecialConfirmationNeeded === true && this.occurrenceForm._specialConfirmationStatus != true) {
                this._onOccurrenceFormError(this.translations["OccurrenceForm__Submit_SpecialConfirmationNeeded"]);
                return;
            }

            this._submitInProgess = true;

            var bIsNew = this.occurrenceForm.entityID == null;

            this._onOccurrenceFormError("");
            domClass.add(this.btn_submit, "w3-disabled");
            domClass.remove(this.btn_submit, "mds-hover-bright");
            this.occurrenceForm.saveOccurrenceData(lang.hitch(this, "_onSubmitNewOccurrenceResponse", bIsNew));
            //this._onClick_Modal_Close(evt);
        },

        _onSubmitNewOccurrenceResponse: function (bIsNew, response) {
            //console.log("_onSubmitNewOccurrenceResponse", this.domNode);
            
            this.emit("EntitySaved");

            if (bIsNew === true) {
                this.showMessage(this.translations["OccurrenceHome__NewEntitySavedHeading"], this.translations["OccurrenceHome__NewEntitySavedConfirmation"], null, lang.hitch(this, "_onClick_Modal_Close")); //"Meldung wurde aufgenommen / Thanks for your request", "Your request has been successfully submitted!"
            } else {
                this._onClick_Modal_Close();
            }
        },

        _onClick_Modal_Close: function (evt) {
            domClass.add(this.modalDlg, "w3-hide");
            domClass.remove(this.modalDlg, "w3-show");

            this.emit("OccurrenceFormClosed");

            domConstruct.destroy(this.occurrenceForm.domNode); // optional?
            this.occurrenceForm = null;

            this.destroy();
        },

        _onClick_Modal_Reload: function (evt) {
            this._isCancelAvailable = -3;
            this.set("Employee", this.employee);
            this.occurrenceForm.startup(true);
        },

        _onOccurrenceFormError: function (message) {
            this._submitInProgess = false;
            domClass.remove(this.btn_submit, "w3-disabled");
            domClass.add(this.btn_submit, "mds-hover-bright");
            domAttr.set(this.errorMsgNode, "innerHTML", message);
        },

        showMessage: function (header, message, subtitle, callback) {
            var dialog = new GenericDialog();

            if (typeof (subtitle) == "string") {
                dialog.set("subtitle", subtitle);
            } else {
                dialog.hideSubtitleNode();
            }

            this.genericDialog = dialog;
            domStyle.set(dialog.textNode, "height", "unset");

            dialog.set("header", header);
            dialog.set("content", message);
            dialog.set("callback", lang.hitch(this, "showMessageCallback", callback));

            dialog.set("ok", true);
            //dialog.set("cancel", true);

            dialog.show();
        },

        showMessageCallback: function (callback) {
            if (typeof (callback) == "function") {
                callback();
            }

            this.genericDialog = null;
        }
    });
